import { PublicClientApplication } from "@azure/msal-browser";
import React, { Component, useEffect, useState } from "react";
import { DataAccess } from "../../../data/DataAccess";
import { GridWrapper } from "../../../integrations/UoE-Grid/GridWrapper";
import { Logging } from "../../../Logging";
import "../../../assets/css/AOS2/AOS2_Search.css";
import { AgentSidebar } from "../Components/AgentSidebar";
import {
  Link,
  NavigateFunction,
  useLoaderData,
  useNavigate,
} from "react-router-dom";

interface AOS2SearchProps {
  Logger: Logging;
  da: DataAccess;
  PCA: PublicClientApplication;

  URLRoot: string;
  URLParams: string;
  Mode: string[];
  Refresher: string;
  Alias: string;
  AliasChecked: NonNullable<boolean>;
  ViewAsAll: boolean;
  Refresh: () => void;
  GetLink: (
    NewModes: { Mode: string; Index: number }[],
    NewParams: { Name: string; Value: string }[],
  ) => string;
  RegisterError: (Reference: string, Message: string) => void;
  DeregisterError: (Reference: string) => void;
  RegisterStatus: (Reference: string, Message: string) => void;
  DeregisterStatus: (Reference: string) => void;

  ActiveSearchTerm: string;
  NewSearchTerm: string;
  setNewSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  NewSearchTermInvalid: boolean;
  ActiveSearchTermInvalid: boolean;

  AgentName: string;
  AgentEmail: string;
  AgentReference: string;
  AgentContactName: string;
  AgentAddress: string;
  AgentCountry: string;
  AgentIsPAS: boolean;
  Navigate: NavigateFunction;
}

function AOS2_SEARCH(params): React.ReactElement {
  let search: any = useLoaderData();
  let navigate = useNavigate();

  const ActiveSearchTerm = (search.SearchTerm as string) ?? "";
  const [ActiveSearchTermInvalid, setActiveSearchTermInvalid] = useState(false);
  const [NewSearchTerm, setNewSearchTerm] = useState(search.SearchTerm);
  const [NewSearchTermInvalid, setNewSearchTermInvalid] = useState(false);

  const AllNumericPattern = /^[0-9]+$/g; // all numeric

  useEffect(() => {
    let IsAllNumeric = AllNumericPattern.test(NewSearchTerm);
    let IsDigits_AndThreeOrMore = IsAllNumeric && NewSearchTerm.length >= 3;
    let NotJustDigits_AndTwoOrMore = !IsAllNumeric && NewSearchTerm.length >= 2;

    if (
      NewSearchTerm !== undefined && // if the new search term exists
      NewSearchTerm.replaceAll(" ", "").length > 0 && // if the new search term isn't all spaces
      !IsDigits_AndThreeOrMore && // if the new search term is contains any letters and is 2 characters or less
      !NotJustDigits_AndTwoOrMore // if the new search term is three digits or less
    ) {
      //console.log("search term is invalid");
      setNewSearchTermInvalid(true);
    } else {
      //console.log("search term is valid");
      setNewSearchTermInvalid(false);
    }
  }, [NewSearchTerm]);

  useEffect(() => {
    let inv = true;

    let IsAllNumeric = AllNumericPattern.test(ActiveSearchTerm);
    let IsDigits_AndThreeOrMore = IsAllNumeric && ActiveSearchTerm.length >= 3;
    let NotJustDigits_AndTwoOrMore =
      !IsAllNumeric && ActiveSearchTerm.length >= 2;

    if (
      NewSearchTerm !== undefined && // if the new search term exists
      NewSearchTerm.replaceAll(" ", "").length > 0 && // if the new search term isn't all spaces
      !IsDigits_AndThreeOrMore && // if the new search term is contains any letters and is 2 characters or less
      !NotJustDigits_AndTwoOrMore // if the new search term is three digits or less
    ) {
      //console.log("active search term is invalid");
      setActiveSearchTermInvalid(true);
    } else {
      //console.log("active search term is valid");
      setActiveSearchTermInvalid(false);
    }
  }, [search.SearchTerm]);

  return (
    <AOS2_SEARCH_INNER
      {...params}
      Navigate={navigate}
      NewSearchTerm={NewSearchTerm}
      setNewSearchTerm={setNewSearchTerm}
      NewSearchTermInvalid={NewSearchTermInvalid}
      ActiveSearchTerm={search.SearchTerm}
      ActiveSearchTermInvalid={ActiveSearchTermInvalid}
    />
  );
}

class AOS2_SEARCH_INNER extends Component<AOS2SearchProps> {
  constructor(props: AOS2SearchProps) {
    super(props);
  }

  render() {
    var PassToAllGrids = {
      Callouts: false,
      Logger: this.props.Logger,
      da: this.props.da,
      PCA: this.props.PCA,
      GetLink: this.props.GetLink,
      URLRoot: this.props.URLRoot,
      URLParams: this.props.URLParams,
      prid: this.props.Mode[1],
      class: "UoE-Grid AOS-AppList",
      Refresher: this.props.Refresher,
      Alias: this.props.Alias,
      AliasChecked: this.props.AliasChecked,
      ViewAsAll: this.props.ViewAsAll,
      RegisterError: this.props.RegisterError,
      DeregisterError: this.props.DeregisterError,
      RegisterStatus: this.props.RegisterStatus,
      DeregisterStatus: this.props.DeregisterStatus,
    };

    return (
      <React.Fragment>
        <AgentSidebar />
        <div className="ResultsPanel Search">
          <h2>Search All Applications</h2>
          <div className="Desc">
            Enter PG Number, DA Number, or Surname.
            <br />
            <p>(2 characters or 3 digits minimum search value)</p>
          </div>
          <input
            id="SearchText"
            className="SearchText"
            type="text"
            pattern="^[0-9A-Za-z '\-]*$"
            value={this.props.NewSearchTerm}
            onChange={(event) => {
              const inp = event.target.value;
              this.props.setNewSearchTerm(inp);
            }}
            onKeyUp={(ev) => {
              if (ev.key === "Enter") {
                if (!this.props.NewSearchTermInvalid) {
                  this.props.Navigate(
                    "/search/" +
                      this.props.NewSearchTerm.trim().replaceAll(" ", "_"),
                  );
                }
              }
            }}
          />
          <Link
            id="MainSearchButton"
            className="SearchButton"
            onClick={(ev) => {
              if (!this.props.NewSearchTermInvalid) {
                this.props.Navigate(
                  "/search/" +
                    this.props.NewSearchTerm.trim().replaceAll(" ", "_"),
                );
              } else {
                ev.preventDefault();
              }
            }}
            to={
              "/search/" + this.props.NewSearchTerm.trim().replaceAll(" ", "_")
            }
          >
            Search
          </Link>
          {this.props.NewSearchTermInvalid ? (
            <React.Fragment>
              <div className="InvalidSearchIdentifier">
                This search term is invalid. Please alter and try again.
              </div>
            </React.Fragment>
          ) : (
            <></>
          )}
          {this.props.ActiveSearchTerm !== undefined &&
          this.props.ActiveSearchTerm !== "" &&
          !this.props.ActiveSearchTermInvalid ? (
            <React.Fragment>
              <div className="SearchKey">
                <div className="UGCurrentApp"></div>
                <div className="KeyLabel">
                  Current Undergraduate Application
                </div>
                <div className="UGPastApp"></div>
                <div className="KeyLabel">
                  Archive Undergraduate Application
                </div>
                <div className="PGCurrentApp"></div>
                <div className="KeyLabel">Current Postgraduate Application</div>
                <div className="PGPastApp"></div>
                <div className="KeyLabel">Archive Postgraduate Application</div>
              </div>
              <GridWrapper
                eid={"AOS_Search_" + this.props.Refresher}
                {...{
                  ...PassToAllGrids,
                  class: PassToAllGrids.class.replace("AOS-AppList", "Search"),
                }}
                sproc="sputilities.webui.AOSv2_AllApplicantSearch"
                params={[
                  "@username",
                  "{%iu}",
                  "@searchterm",
                  this.props.ActiveSearchTerm,
                ]}
                rename="URL,Name_URL"
              ></GridWrapper>
            </React.Fragment>
          ) : (
            ""
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default AOS2_SEARCH;
